import { Box, Select, VStack } from '@chakra-ui/react'
import { Mic, Speaker, VideoCamera } from '@components/icons'
import {
  useDevices,
  useLocalSessionId,
  useParticipantIds
} from '@daily-co/daily-react'
import React from 'react'
import {
  DialogBody,
  DialogContainer,
  DialogHeader
} from '../../../components/dialog'
import { useActiveTelehealthSession } from '../context/active-telehealth-session.context'
import { AVDeviceSelector } from './av-device-selector'
import { ParticipantTile } from './participant-tile'
import { SettingsActionBar } from './settings-action-bar'

export const DeviceSettingsModal = ({
  isOpen,
  onClose
}: {
  isOpen: boolean
  onClose: () => void
}) => {
  const devices = useDevices()
  const localId = useLocalSessionId()

  const handleMicInputChange = (event: any) => {
    devices.setMicrophone(event.target.value)
  }

  const handleCamInputChange = (event: any) => {
    devices.setCamera(event.target.value)
  }

  const handleSpeakerInputChange = (event: any) => {
    devices.setSpeaker(event.target.value)
  }

  return (
    <DialogContainer scrollBehavior="inside" isOpen={isOpen} onClose={onClose}>
      <DialogHeader text="Settings" onClose={onClose} />
      <DialogBody>
        <Box borderRadius="12px" bg="black" h="auto" w="100%" overflow="hidden">
          <ParticipantTile
            participantId={localId}
            aspectRatio={16 / 9}
            setAspectRatio={() => {}}
            videoFitOverride="contain"
            borderRadius="0px"
          />
        </Box>
        <SettingsActionBar />
        <VStack p="small" spacing="small">
          <AVDeviceSelector
            type="camera"
            icon={<VideoCamera width="24px" />}
            devices={devices.cameras}
            selectedDeviceId={devices.currentCam?.device.deviceId || ''}
            onDeviceChange={handleCamInputChange}
            isBlocked={devices.hasCamError}
          />
          <AVDeviceSelector
            type="microphone"
            icon={<Mic width="24px" />}
            devices={devices.microphones}
            selectedDeviceId={devices.currentMic?.device.deviceId || ''}
            onDeviceChange={handleMicInputChange}
            isBlocked={devices.hasMicError}
          />
          <AVDeviceSelector
            type="speaker"
            icon={<Speaker width="24px" />}
            devices={devices.speakers}
            selectedDeviceId={devices.currentSpeaker?.device.deviceId || ''}
            onDeviceChange={handleSpeakerInputChange}
            isBlocked={devices.hasMicError}
          />
        </VStack>
      </DialogBody>
    </DialogContainer>
  )
}
